import ReactGA from 'react-ga4';
import config from '../config';

/**
 * Inicializa o Google Analytics
 */
export const initGA = () => {
  // Verifica se o Measurement ID está configurado
  if (config.googleAnalyticsMeasurementId) {
    ReactGA.initialize(config.googleAnalyticsMeasurementId, {
      gaOptions: {
        // Configurações adicionais podem ser adicionadas aqui
        // cookieFlags: 'SameSite=None;Secure',
      },
      gtagOptions: {
        // Opções do gtag podem ser adicionadas aqui
        // anonymize_ip: true,
      },
    });
    
    console.log('Google Analytics inicializado:', config.googleAnalyticsMeasurementId);
  } else {
    console.warn('Google Analytics Measurement ID não configurado');
  }
};

/**
 * Rastreia uma visualização de página
 * @param {string} path - Caminho da página
 * @param {string} title - Título da página (opcional)
 */
export const trackPageView = (path, title) => {
  if (config.googleAnalyticsMeasurementId) {
    ReactGA.send({ 
      hitType: 'pageview', 
      page: path,
      title: title || document.title 
    });
  }
};

/**
 * Rastreia um evento personalizado
 * @param {string} category - Categoria do evento
 * @param {string} action - Ação do evento
 * @param {string} label - Label do evento (opcional)
 * @param {number} value - Valor numérico (opcional)
 */
export const trackEvent = (category, action, label, value) => {
  if (config.googleAnalyticsMeasurementId) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

/**
 * Rastreia uma exceção/erro
 * @param {string} description - Descrição do erro
 * @param {boolean} fatal - Se o erro é fatal
 */
export const trackException = (description, fatal = false) => {
  if (config.googleAnalyticsMeasurementId) {
    ReactGA.event('exception', {
      description,
      fatal,
    });
  }
};

/**
 * Define propriedades do usuário
 * @param {Object} properties - Propriedades do usuário
 */
export const setUserProperties = (properties) => {
  if (config.googleAnalyticsMeasurementId) {
    ReactGA.set(properties);
  }
};

/**
 * Rastreia tempo de carregamento
 * @param {string} category - Categoria
 * @param {string} variable - Nome da variável
 * @param {number} time - Tempo em milissegundos
 * @param {string} label - Label (opcional)
 */
export const trackTiming = (category, variable, time, label) => {
  if (config.googleAnalyticsMeasurementId) {
    ReactGA.event('timing_complete', {
      name: variable,
      value: time,
      event_category: category,
      event_label: label,
    });
  }
};
